import Vue from 'vue'
import about_us from './common/about_us'
import banner_star from './common/banner_star'
import customer_case from './common/customer_case'
import product_center from './common/product_center'
import product_function from './common/product_center/product_function'
import product_advantage from './common/product_center/product_advantage'
import product_features from './common/product_center/product_features'
import customer_pain_point from './common/product_center/customer_pain_point'
import technical_features from './common/product_center/technical_features'
import service_scope from './common/service_scope'
import corporate_culture from './common/corporate_culture'
import foot from './layout/foot'
import header_nav from './layout/header_nav'
const components = {
  about_us,
  customer_case,
  product_center,
  service_scope,
  corporate_culture,
  foot,
  header_nav,
  product_function,
  product_advantage,
  product_features,
  customer_pain_point,
  technical_features,
  banner_star,
}
Object.keys(components).forEach(key => {
  let component = components[key]
  Vue.component(component.name, component)
})
export default components



// WEBPACK FOOTER //
// ./src/components/index.js